import GenericLangValue from "./GenericLangValue";
import AdmsIdentifier from "./AdmsIdentifier";
import {keys} from "../config/nameSpacesKeys";

export default class MsLanguageResource {
  constructor(name, initialValue, namespace, admsNameSpace, notationNameSpace, schemaAgencyNameSpace, isEditor = false) {
    this.namespace = namespace;
    this.name = name;
    this.title = new GenericLangValue(name = "title", null, keys.title);
    this.description = new GenericLangValue(name = "description", null, keys.description);
    this.admsNameSpace = admsNameSpace;
    this.notationNameSpace = notationNameSpace;
    this.schemaAgencyNameSpace = schemaAgencyNameSpace;
    this.isEditor = isEditor;
    this.admsList = [];
    if (initialValue) {
      this.parseInputJSON(initialValue);
    } else {
      this.createEmptyAdmsObj();
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getAdmsIdentifiersList() {
    return this.admsList;
  }

  setAdmsIdentifiersList(fadmsList) {
    this.admsList = fadmsList;
  }

  createEmptyAdmsObj() {
    const adms = new AdmsIdentifier(this.name, null, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    this.admsList.push(adms);
  }

  createAdmsObj(obj) {
    const adms = new AdmsIdentifier(this.name, obj, this.admsNameSpace, this.notationNameSpace, this.schemaAgencyNameSpace);
    // adms.parseInputJSON(obj);
    this.admsList.push(adms);
  }

  removeAdmsObj(obj, index) {
    if (index < 0 || index >= this.admsList.length) {
      return false;
    }
    this.admsList.splice(index, 1);
  }

  setAdms(inputObj) {
    const admsObj = inputObj[this.admsNameSpace];
    if (Array.isArray(admsObj)) {
      for (const entry of Object.entries(admsObj)) {
        const value = entry[1];
        this.createAdmsObj(value);
      }
    } else {
      if (!admsObj && this.isEditor) { // if it is coming from the editor, and the identifier was not fiiled out, then it is empy
        this.createAdmsObj(admsObj); // we have to add an object to render the form correctly
      }
    }
  }

  parseInputJSON(inputJSON) {
    const obj = inputJSON;
    if (Array.isArray(obj)) {
      for (const entry of Object.entries(obj)) {
        const value = entry[1];
        this.parseObj(value);
      }
    } else {
      this.parseObj(obj);
    }
  }

  parseObj(obj) {
    this.title.parseInputJSON(obj);
    this.description.parseInputJSON(obj);
    this.setAdms(obj);
  }

  getExpandedFormatValue() {
    const obj = {};
    const title = this.title.getExpandedFormatValue();
    obj[this.title.getNameSpace()] = title;

    const description = this.description.getExpandedFormatValue();
    obj[this.description.getNameSpace()] = description;

    const admsExpanded = [];
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      admsExpanded.push(admsItem.getExpandedFormatValue());
    }
    obj[this.admsNameSpace] = admsExpanded;
    // obj[assetKeys.type] = [`${this.namespace}`];
    return obj;
  }

  isEmpty() {
    const condition1 = this.title.isEmpty();
    const condition2 = this.description.isEmpty();
    let condition3 = true;
    for (let index = 0; index < this.admsList.length; index++) {
      const admsItem = this.admsList[index];
      condition3 = condition3 && admsItem.isEmpty();
    }
    return condition1 && condition2 && condition3;
  }
}
